/**
 * Constants for event categories used in analytics tracking.
 *
 * These categories help organize events into logical groups.
 */

export const EVENT_CATEGORIES = {
  ACCOUNT_SETTINGS: 'account_settings',
  ADVANCED_SETTINGS: 'advanced_settings',
  APP_LIFECYCLE: 'app_lifecycle',
  AUTH: 'auth',
  AUDIO_SOURCES: 'audio_sources',
  AUTO_TRACKING: 'auto_tracking',
  BILLING: 'billing',
  BRIDGE: 'bridge',
  CALIBRATION: 'calibration',
  COLLABORATION: 'collaboration',
  CONTROL_TRAY: 'control_tray',
  CONTROLLERS: 'controllers',
  DEVICE: 'device',
  GRIDLINES: 'gridlines',
  IMAGE_TRAY: 'image_tray',
  MONITORING: 'monitoring',
  MOVEMENT_TOOLS: 'movement_tools',
  NOTIFICATIONS: 'notifications',
  ONBOARDING: 'onboarding',
  ORGANIZATION: 'organization',
  PREQUALIFICATION: 'prequalification',
  RECORDING: 'recording',
  // ENG-4324 (SCR-1): category for the named in-studio screen_* view events.
  SCREEN: 'screen',
  SECURITY: 'security',
  SHARING: 'sharing',
  STUDIO: 'studio',
  USER: 'user',
  VIDEO_MODES: 'video_modes',
  VIDEO_SETTINGS: 'video_settings',
  VIDEO_SOURCES: 'video_sources',
  VIEW: 'view',
  WORKSPACE: 'workspace'
} as const;

export type EventCategory = (typeof EVENT_CATEGORIES)[keyof typeof EVENT_CATEGORIES];
